import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { MoreDots } from 'blaze-ui/icons'
import { useQueryClient } from 'react-query'
import { DocMenuContainer } from 'components/DocMenu/DocMenuContainer'
import { DesignMenuContainer } from 'components/DesignMenu/DesignMenuContainer'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { PostActionsButtonProps } from './Types'
import { removeItemFromCalendarCache } from 'hooks/queries/calendar/utils'
import { calendarKeys } from 'hooks/queries/calendar/calendarKeys'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { scheduledPostsKeys } from 'hooks/queries/scheduledPosts/scheduledPostsKeys'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

export const PostActionsButton = ({ almanacFile, isDisabled, onDelete }: PostActionsButtonProps) => {
  const queryClient = useQueryClient()
  const workspaceId = useCurrentWorkspaceId()
  const isSystemRedesignEnabled = useIsSystemRedesign()

  const docMenuPopover = (close: () => void) => (
    <>
      {almanacFile && (
        <DocMenuContainer
          id={almanacFile.key}
          hiddenKeys={
            new Set([
              'toggleVersionControl',
              'switchView',
              'cleanup',
              'readHistory',
              'toggleFocus',
              'readInsights',
              'rename',
              'publish',
            ])
          }
          onDeleteSuccess={() => {
            onDelete()
            removeItemFromCalendarCache(queryClient, almanacFile.key)
            queryClient.invalidateQueries(calendarKeys.detailAll())
            queryClient.invalidateQueries(scheduledPostsKeys.index(workspaceId))
          }}
          onAction={close}
          dismiss={close}
        />
      )}
    </>
  )

  const designMenuPopover = (close: () => void) => (
    <>
      {almanacFile && (
        <DesignMenuContainer
          id={almanacFile?.key}
          hiddenKeys={new Set(['rename'])}
          onDeleteSuccess={() => {
            onDelete()
            removeItemFromCalendarCache(queryClient, almanacFile.key)
            queryClient.invalidateQueries(calendarKeys.detailAll())
          }}
          onAction={close}
          dismiss={close}
        />
      )}
    </>
  )

  return (
    <DropdownTrigger placement="bottom-end" restoreFocus={false}>
      <IconButton
        icon={MoreDots}
        variant="tertiary"
        size={isSystemRedesignEnabled ? 'md' : 'lg'}
        isDisabled={isDisabled}
        rounded={!isSystemRedesignEnabled}
      />
      {(close) => {
        if (almanacFile?.asset_type === 'Article') return docMenuPopover(close)

        return designMenuPopover(close)
      }}
    </DropdownTrigger>
  )
}
